export type ThemeChoice = 'system' | 'light' | 'dark';
export type ResolvedTheme = 'light' | 'dark';

const STORAGE_KEY = 'shelf.theme';

const media = () => window.matchMedia('(prefers-color-scheme: dark)');

/** Follows the device until you pick one; an explicit choice is remembered.
 *  (index.html applies the same rule before the app loads, so the launch
 *  screen is already in the right theme.) */
export function loadThemeChoice(): ThemeChoice {
  const raw = localStorage.getItem(STORAGE_KEY);
  return raw === 'light' || raw === 'dark' || raw === 'system' ? raw : 'system';
}

export function resolveTheme(choice: ThemeChoice): ResolvedTheme {
  if (choice === 'system') return media().matches ? 'dark' : 'light';
  return choice;
}

/** Applies the theme to <html> and keeps the browser chrome colour in step. */
export function applyTheme(choice: ThemeChoice): ResolvedTheme {
  const resolved = resolveTheme(choice);
  document.documentElement.setAttribute('data-theme', resolved);
  localStorage.setItem(STORAGE_KEY, choice);

  const bar = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]:not([media])');
  const colour = resolved === 'dark' ? '#101b33' : '#dfe6f3';
  if (bar) bar.content = colour;
  return resolved;
}

/** Calls back when the OS theme changes, so 'system' stays live. */
export function watchSystemTheme(onChange: () => void): () => void {
  const mq = media();
  mq.addEventListener('change', onChange);
  return () => mq.removeEventListener('change', onChange);
}
